import isPlanPPO from 'utils/pivot/plan/isPlanPPO'

function hasEpicPPO(ids, plans) {
  return ids.some(id => isPlanPPO(plans[id]))
}

export default hasEpicPPO
